import { render, staticRenderFns } from "./AgentCatagory.vue?vue&type=template&id=6427c67f&scoped=true"
import script from "./AgentCatagory.vue?vue&type=script&lang=js"
export * from "./AgentCatagory.vue?vue&type=script&lang=js"
import style0 from "./AgentCatagory.vue?vue&type=style&index=0&id=6427c67f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427c67f",
  null
  
)

export default component.exports